import React, { useMemo, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import MainMenuOverlay from "../components/MainMenu/MainMenuOverlay";
import CleanTechBackground from "../components/CleanTechBackground";

export default function MainMenuPage() {
  React.useEffect(() => { document.title = 'ИНСЕРВ — главное меню'; }, []);
  const [open, setOpen] = useState(true);
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const force = params.get("force") === "1";
  const skipParam = params.get("skip") === "1";
  const silent = params.get("silent") === "1";

  const overrides = useMemo(
    () => ({ force, skipParam, silent }),
    [force, skipParam, silent]
  );

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (window.history.length <= 1) navigate("/");
      else navigate(-1);
    }, 150);
  };

  return (
    <div style={{ position: 'relative', minHeight: "100vh", background: "#0f0e16" }}>
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <CleanTechBackground opacity={0.35} />
      </div>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <MainMenuOverlay
          open={open}
          onClose={handleClose}
          routeMode
          overrides={overrides}
        />
      </div>
    </div>
  );
}